/**
 * @spec docs/specs/features/staking-position-ui.md#design-system
 *
 * Main layout component that wraps all pages.
 * Provides consistent header and page structure.
 */
import { Header } from './Header';

interface LayoutProps {
  children: React.ReactNode;
}

/**
 * Application layout with header and main content area
 */
export function Layout({ children }: LayoutProps) {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1">{children}</main>
    </div>
  );
}
